import "./DocumentList.scss";

import type { DocumentType } from "../DocumentTypes";

type DocumentListProps = {
  documents: DocumentType[];
  isLoading?: boolean;
  isError?: boolean;
};

const DocumentList = ({ documents, isLoading, isError }: DocumentListProps) => {
  if (isLoading) {
    return <div className="document-list-loading">Loading documents...</div>;
  }

  if (isError) {
    return <div className="document-list-error">Error loading documents</div>;
  }

  if (!documents.length) {
    return (
      <div className="document-list-empty">
        <span className="material-icons">description</span>
        <p>No documents available</p>
      </div>
    );
  }

  return (
    <div className="document-list">
      {documents.map((doc) => (
        <div key={doc.id} className="document-list-item">
          {doc.original_filename}
        </div>
      ))}
    </div>
  );
};

export default DocumentList;
